import React from 'react'
import Status from 'components/global/Status'
import { useTranslation } from 'react-i18next'

export const ActivateUser = ({ table }) => {
  const { t } = useTranslation()
  return (
    <Status
      status={t('auth.account_status.activated')}
      color={'#587F31'}
      bgcolor={'#E6F0D7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius="50px"
      isUppercase={false}
    />
  )
}

export const PendingUser = ({ table }) => {
  const { t } = useTranslation()
  return (
    <Status
      status={t('auth.account_status.pending')}
      color={'#D97706'}
      bgcolor={'#FEF3C7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius="50px"
      isUppercase={false}
    />
  )
}

export const LockedUser = ({ table }) => {
  const { t } = useTranslation()
  return (
    <Status
      status={t('auth.account_status.locked')}
      color={'#D97706'}
      bgcolor={'#FEF3C7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius="50px"
      isUppercase={false}
    />
  )
}

export const NoSyncUser = ({ table }) => {
  const { t } = useTranslation()
  return (
    <Status
      status={t('auth.account_status.not_sync')}
      color={'#DC2626'}
      bgcolor={'#FEE2E2'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius="50px"
      isUppercase={false}
    />
  )
}

export const DeactivateUser = ({ table }) => {
  const { t } = useTranslation()
  return (
    <Status
      status={t('auth.account_status.disabled')}
      color={'#5D5D5D'}
      bgcolor={'#E7E7E7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius="50px"
      isUppercase={false}
    />
  )
}

export const PasswordLocked = ({ table }) => {
  const { t } = useTranslation()
  return (
    <Status
      status={t('auth.account_status.password_locked')}
      color={'#5D5D5D'}
      bgcolor={'#E7E7E7'}
      fontSize={table ? 10 : 12}
      height={24}
      borderRadius="50px"
      isUppercase={false}
    />
  )
}
